export default __webpack_public_path__ + "static/media/tota-videos-icon.b3f1ebdb.svg";